
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classes/[[...categorySlug]]",
      function () {
        return require("private-next-pages/classes/[[...categorySlug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classes/[[...categorySlug]]"])
      });
    }
  